// File: filter_options.ts

import { FilterOption } from "../types";
import images from "./assets/images";

// Define the filter options with both light and dark icons
export const filterOptions: FilterOption[] = [
  {
    id: "events",
    name: "Events",
    lightIcon: images.whiteEventsIcon,
    darkIcon: images.darkEventsIcon,
  },
  {
    id: "realEstate",
    name: "Real Estate",
    lightIcon: images.whiteBuildingIcon,
    darkIcon: images.darkBuildingIcon,
  },
  {
    id: "cartography",
    name: "Cartography",
    lightIcon: images.whiteFilmIcon,
    darkIcon: images.darkFilmIcon,
  },
  {
    id: "constructions",
    name: "Constructions",
    lightIcon: images.whiteBuildingIcon,
    darkIcon: images.darkBuildingIcon,
  },
  {
    id: "agriculture",
    name: "Agriculture",
    lightIcon: images.whiteAgricultureIcon,
    darkIcon: images.darkAgricultureIcon,
  },
  {
    id: "commercial",
    name: "Commercial",
    lightIcon: images.whiteFilmIcon,
    darkIcon: images.darkFilmIcon,
  },
  {
    id: "energy",
    name: "Energy/Solar panels",
    lightIcon: images.whiteEnergyIcon,
    darkIcon: images.darkEnergyIcon,
  },
  {
    id: "journalism",
    name: "Journalism",
    lightIcon: images.whiteJournalismIcon,
    darkIcon: images.darkJournalismIcon,
  },
  {
    id: "extremeSports",
    name: "Extreme sports",
    lightIcon: images.whiteSportsIcon,
    darkIcon: images.darkSportsIcon,
  },
  {
    id: "natureConservation",
    name: "Nature Conservation",
    lightIcon: images.whiteBuildingIcon,
    darkIcon: images.darkBuildingIcon,
  },
  {
    id: "droneLightShows",
    name: "Drone Light Shows",
    lightIcon: images.whiteDroneIcon,
    darkIcon: images.darkDroneIcon,
  },
  {
    id: "insurances",
    name: "Insurances",
    lightIcon: images.whiteInsuranceIcon,
    darkIcon: images.darkInsuranceIcon,
  },
];
